import app from 'app';
import templateUrl from './submitClaim.html';
import './submitClaim.scss';

import { logEvent, eventCategories } from 'helpers/analytics';

import './submitClaimService';
import './submitClaimPageHeader/submitClaimPageHeader';
import './pages/submitClaimBillUpload/submitClaimBillUpload';
import './pages/submitClaimDownloadForm/submitClaimDownloadForm';
import './pages/submitClaimError/submitClaimError';
import './pages/submitClaimIncompleteBill/submitClaimIncompleteBill';
import './pages/submitClaimMedicalQuestions/submitClaimMedicalQuestions';
import './pages/submitClaimReview/submitClaimReview';
import './pages/submitClaimSelector/submitClaimSelector';
import './pages/submitClaimSuccessful/submitClaimSuccessful';
import './pages/submitClaimUnpaid/submitClaimUnpaid';
import './pages/submitClaimUploading/submitClaimUploading';
import './pages/submitClaimVerifyBill/submitClaimVerifyBill';

import mxConfirmationModal from 'components/modals/mxConfirmationModal/mxConfirmationModal';

function SubmitClaim(
  $anchorScroll,
  $transitions,
  $q,
  chModal,
  SubmitClaimService,
  Session
) {
  const SubmitClaim = this;

  function shouldSkipSelectorPage() {
    return SubmitClaim.planTypes.length < 2;
  }

  SubmitClaim.getTitle = function() {
    switch (SubmitClaim.page) {
      case 'medical':
        return 'About your claim';
      case 'medical_upload_bill':
        return 'Attach your bill';
      case 'verify_bill':
        return 'Verify your bill';
      case 'incomplete_bill':
        return 'Incomplete bill';
      case 'dental':
        return 'Dental Claim';
      case 'vision':
        return 'Vision Claim';
      case 'pharmacy':
        return 'Pharmacy Claim';
      case 'unpaid_claim':
        return 'Unpaid Claim';
      case 'review':
        return 'Review & submit';
      case 'successful':
        return 'Next steps';
      case 'uploading':
      case 'error':
        return 'Submitting claim';
      default:
        return 'Submit an out-of-network claim';
    }
  };

  SubmitClaim.submit = function() {
    SubmitClaim.page = 'uploading';

    SubmitClaimService.submitClaim(
      SubmitClaim.files,
      SubmitClaim.plans.medical.submitterId,
      SubmitClaim.patientId,
      SubmitClaim.cob
    )
      .then(response => {
        SubmitClaim.issueId = response.issueId;
        SubmitClaim.page = 'successful';
        SubmitClaim.files = [];
      })
      .catch(() => {
        SubmitClaim.error =
          'There was an error with your submission. Please try again.';
        SubmitClaim.page = 'error';
      });
  };

  SubmitClaim.$onInit = function() {
    SubmitClaim.shouldSkipSelectorPage = shouldSkipSelectorPage();
    if (SubmitClaim.shouldSkipSelectorPage) {
      SubmitClaim.page = SubmitClaim.planTypes[0];
    }

    SubmitClaim.removeTransitionHandler = $transitions.onBefore(
      { from: 'SubmitClaim', to: '*' },
      () => {
        if (
          !SubmitClaim.files ||
          SubmitClaim.files.length === 0 ||
          !Session.hasSession()
        ) {
          return true;
        }

        const deferred = $q.defer();
        chModal
          .open({
            component: mxConfirmationModal,
            locals: {
              body: 'Information entered up to this point will not be saved.',
              confirm: 'Yes',
              cancel: 'No',
              header: 'Are you sure you want to leave?'
            }
          })
          .on('close', confirmed => {
            if (confirmed) {
              deferred.resolve();
            } else {
              deferred.reject();
            }
          });
        return deferred.promise;
      }
    );
  };

  SubmitClaim.$onDestroy = function() {
    logEvent('MSOONFlowExited', {
      category: eventCategories.MSOON
    });
    if (SubmitClaim.removeTransitionHandler) {
      SubmitClaim.removeTransitionHandler();
    }
  };

  let previousPage;

  SubmitClaim.$doCheck = function() {
    if (SubmitClaim.page !== previousPage) {
      previousPage = SubmitClaim.page;
      $anchorScroll();
    }
  };
}

app.component('submitClaim', {
  bindings: {
    currentUser: '<',
    plans: '<',
    planTypes: '<',
    currentSponsorship: '<'
  },
  controller: SubmitClaim,
  controllerAs: 'SubmitClaim',
  templateUrl
});

export default 'submitClaim';
